module.exports = __webpack_public_path__ + "static/img/Logo2.10a9eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo2.png
// module id = ZWRV
// module chunks = 2